import DOMPurify from "dompurify";

// Allow only the tags/attributes our TipTap editor produces.
const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "b", "strong", "i", "em", "u", "s", "code", "pre", "mark",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "ul", "ol", "li",
    "blockquote", "hr",
    "a", "span",
    "table", "thead", "tbody", "tr", "td", "th", "colgroup", "col",
    "img",
  ],
  ALLOWED_ATTR: [
    "href", "rel", "class", "style",
    "colspan", "rowspan",
    "src", "alt", "width", "height",
    "data-color", "data-background-color",
    "data-eo-note", "data-eo-doc", "data-eo-page", "data-eo-draft",
    "role", "tabindex",
  ],
  // Allow http(s), mailto, and data: (for embedded images)
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|data):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
  ALLOW_DATA_ATTR: false,
};

export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(String(html), CONFIG);
}

// Ready-made prop object for dangerouslySetInnerHTML.
export function safeHtml(html) {
  return { __html: sanitizeHtml(html) };
}
